import { isEnvEnabled } from '~/lib/env';

export const DEFAULT_PAGE_SIZE = isEnvEnabled(
  'VITE_CONTAINER_SETTINGS_PSSF_ENABLED',
  false,
)
  ? 10
  : 60;

export const DEFAULT_FILTER_LIMIT = 10;
export const DEFAULT_SEARCH_LIMIT = 250;
export const MAX_TAG_CHARACTERS = 30;

export const DEFAULT_DROPDOWN_PAGE_SIZE = isEnvEnabled(
  'VITE_CONTAINER_SETTINGS_DROPDOWN_PAGINATION_ENABLED',
  false,
)
  ? DEFAULT_PAGE_SIZE
  : 1000; // > phase 1 migrated labels/users/label groups
